<template>
  <div class="date-picker" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
      <flat-pickr v-model="currentValue" :config="config" class="form-control" placeholder="Select date" :disabled="elementDisabled"></flat-pickr>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'DatePicker',
  components: {
    flatPickr
  },
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      }
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
